/**
 * 评价模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取评价列表
export const evaluateList = (params) => {
  return req.get('/order/evaluation/listNew', params);
}
//获取评价详情
export const getEvaluate = (orderId) => {
  return req.get(`/order/evaluation/${orderId}`);
}

// 隐藏评价
export const evaluateHide = (params) => {
  return req.put('/order/evaluation/updateShowStatus', params);
}

// 回复评价
export const evaluateReply = (params) => {
  return req.put('/order/evaluation', params);
}
// 评价导出
export const evaluateExport = (params,customConfig) => {
  return req.downloadGet('/order/evaluation/exportNew', params,customConfig,'application/vnd.ms-excel');
}